var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCtaSection02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 182,
    viewBox: "0 0 182 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.5 182L87 110L63 178L49 172.5L80 107L32 161L21 150L75 102L9.5 133L4 119L72 95L0 98.5V83.5L72 87.5L4 63L9.5 49.5L75 80.5L21 32L32 21.5L80 75L49 9.99999L63 3.99999L87 72.5L83.5 0H98.5L94.5 72L119 3.99999L132.5 9.99999L101.5 75L150 21.5L160.5 32L107 80.5L172 49.5L178 63L109.5 87.5L182 83.5V98.5L109.5 95L178 119L172 133L107 102L160.5 150L150 161L101.5 107L132.5 172.5L119 178L94.5 110L98.5 182H83.5Z",
    fill: "#D3EE34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaSection02);
export default __webpack_public_path__ + "static/media/cta_section_02.b02e0d95db6b27a54ddcf95469646fde.svg";
export { ForwardRef as ReactComponent };